import { WhitelabelConfig } from './WhitelabelConfig'
import { CompanyEnumIndices } from '@bdswiss/common-enums'

export const tauroMarketsItaly: WhitelabelConfig = {
  whitelabel: CompanyEnumIndices.tauroMarkets,
  domainNames: ['tauro-markets.com', 'tauro-markets.local'],
  leverageOverrides: {
    'XAGUSD.fx': 200,
    'XAUUSD.fx': 200,
  },
}
